// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileBlock_ProfileBlock__qPPTT {
  display: flex;
  flex: auto;
  flex-direction: column;
  padding: 24px;
  background: var(--white);
  border-radius: 12px;
  position: relative;
}
@media (max-width: 640px) {
  .ProfileBlock_ProfileBlock__qPPTT {
    padding: 16px;
  }
}

.ProfileBlock_additional-information__9I4dg {
  margin-top: auto;
  padding: 8px;
  background: #FAFAFA;
  border-radius: 8px;
  line-height: 18px;
  color: #668899;
}
@media (max-width: 640px) {
  .ProfileBlock_additional-information__9I4dg {
    margin-top: 12px;
  }
}

.ProfileBlock_fio-container__y1k5u {
  display: flex;
  gap: 10px;
  align-items: center;
  max-width: calc(100% - 250px);
}
@media (max-width: 768px) {
  .ProfileBlock_fio-container__y1k5u {
    max-width: none;
  }
}
.ProfileBlock_fio-container__y1k5u .ProfileBlock_fio__R0CfG {
  font-size: 24px;
  line-height: 114%;
  font-weight: 500;
}
.ProfileBlock_fio-container__y1k5u .ProfileBlock_rating__P0hhA {
  padding: 4px 12px 4px 9px;
  background: #EFF3F5;
  border-radius: 27px;
  display: flex;
  justify-content: center;
  gap: 4px;
  font-size: 18px;
  font-weight: 500;
  line-height: 117%;
  align-items: center;
}
.ProfileBlock_fio-container__y1k5u .ProfileBlock_rating__P0hhA svg {
  fill: #F2A60F;
  width: 17px;
  height: 17px;
}
@media (max-width: 640px) {
  .ProfileBlock_fio-container__y1k5u {
    justify-content: space-between;
  }
  .ProfileBlock_fio-container__y1k5u .ProfileBlock_fio__R0CfG {
    font-size: 18px;
  }
  .ProfileBlock_fio-container__y1k5u .ProfileBlock_rating__P0hhA {
    font-size: 16px;
  }
}

.ProfileBlock_info-list__RgRiQ {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
  margin-bottom: 20px;
  max-width: calc(100% - 240px);
}
.ProfileBlock_info-list__item__LtEXN {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ProfileBlock_info-list__item__LtEXN span {
  line-height: 114%;
}
.ProfileBlock_info-list__item__LtEXN .ProfileBlock_item__title__I0sI0 {
  color: #7A808B;
  font-weight: 500;
}
.ProfileBlock_info-list__item__LtEXN .ProfileBlock_item__info__a2FBy {
  font-size: 16px;
}
.ProfileBlock_info-list__item__LtEXN .ProfileBlock_item__info-container__qzL4f {
  display: flex;
  gap: 4px;
  align-items: center;
}
@media (max-width: 640px) {
  .ProfileBlock_info-list__RgRiQ {
    max-width: initial;
    gap: 8px;
    margin-bottom: 12px;
  }
  .ProfileBlock_info-list__item__LtEXN {
    padding-bottom: 8px;
    border-bottom: 1px solid #F3F2F2;
  }
  .ProfileBlock_info-list__item__LtEXN .ProfileBlock_item__title__I0sI0 {
    font-size: 12px;
  }
}

.ProfileBlock_ProfileBlock__cropModal__fHUaP {
  position: absolute;
  right: 24px;
  top: 24px;
}
@media (max-width: 768px) {
  .ProfileBlock_ProfileBlock__cropModal__fHUaP {
    position: relative;
    margin: 12px auto 0;
    width: 100%;
    align-items: center;
    max-width: 304px;
    top: initial;
    right: initial;
  }
  .ProfileBlock_ProfileBlock__cropModal__fHUaP .photo__container {
    width: 100%;
    height: 100%;
  }
}

.ProfileBlock_write-message__block__kvkc7 {
  margin-top: auto;
  border-top: 1px solid #EFF3F5;
}
@media (max-width: 640px) {
  .ProfileBlock_write-message__block__kvkc7 {
    border-top: 0;
  }
}
.ProfileBlock_write-message__block__kvkc7 .ProfileBlock_btn__wT2H0 {
  margin-top: 20px;
  max-width: 240px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background-color: var(--accent-color);
  min-height: 24px;
  border-radius: 12px;
  font-size: var(--fz-sm);
  line-height: var(--fz-lg);
  color: white;
  transition: var(--transition);
  position: relative;
}
@media (hover: hover) {
  .ProfileBlock_write-message__block__kvkc7 .ProfileBlock_btn__wT2H0:hover {
    opacity: 0.8;
  }
}
.ProfileBlock_write-message__block__kvkc7 .ProfileBlock_btn--is-loading__G6h4E svg {
  opacity: 0;
}
.ProfileBlock_write-message__block__kvkc7 .ProfileBlock_btn__wT2H0 svg {
  flex-shrink: 0;
  margin-right: 7px;
}
@media (max-width: 640px) {
  .ProfileBlock_write-message__block__kvkc7 .ProfileBlock_btn__wT2H0 {
    max-width: none;
    margin-top: 0;
  }
}
.ProfileBlock_write-message__block__kvkc7 .ProfileBlock_btn__icon-container__ALFR3 {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/ProfileBlock/ProfileBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EATF;IAUI,aAAA;EAEF;AACF;;AACA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAEF;AAAE;EARF;IASI,gBAAA;EAGF;AACF;;AAAA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;AAGF;AADE;EANF;IAOI,eAAA;EAIF;AACF;AAFE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAIJ;AADE;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAGJ;AADI;EACE,aAAA;EACA,WAAA;EACA,YAAA;AAGN;AACE;EAnCF;IAoCI,8BAAA;EAEF;EAAE;IACE,eAAA;EAEJ;EACE;IACE,eAAA;EACJ;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AAAF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAJ;AAEI;EACE,iBAAA;AAAN;AAGI;EACE,cAAA;EACA,gBAAA;AADN;AAII;EACE,eAAA;AAFN;AAKI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAHN;AAOE;EAjCF;IAkCI,kBAAA;IACA,QAAA;IACA,mBAAA;EAJF;EAME;IACE,mBAAA;IACA,gCAAA;EAJJ;EAMI;IACE,eAAA;EAJN;AACF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AANF;AAQE;EALF;IAMI,kBAAA;IACA,mBAAA;IACA,WAAA;IACA,mBAAA;IACA,gBAAA;IACA,YAAA;IACA,cAAA;EALF;EAQI;IACE,WAAA;IACA,YAAA;EANN;AACF;;AAWA;EACE,gBAAA;EACA,6BAAA;AARF;AAUE;EAJF;IAKI,aAAA;EAPF;AACF;AASE;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AAPJ;AASI;EACE;IACE,YAAA;EAPN;AACF;AAWM;EACE,UAAA;AATR;AAaI;EACE,cAAA;EACA,iBAAA;AAXN;AAcI;EAlCF;IAmCI,eAAA;IACA,aAAA;EAXJ;AACF;AAcE;EACE,kBAAA;AAZJ","sourcesContent":[".ProfileBlock {\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n  padding: 24px;\n  background: var(--white);\n  border-radius: 12px;\n  position: relative;\n\n  @media (max-width: 640px) {\n    padding: 16px;\n  }\n}\n\n.additional-information {\n  margin-top: auto;\n  padding: 8px;\n  background: #FAFAFA;\n  border-radius: 8px;\n  line-height: 18px;\n  color: #668899;\n\n  @media (max-width: 640px) {\n    margin-top: 12px;\n  }\n}\n\n.fio-container {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  max-width: calc(100% - 250px);\n\n  @media (max-width: 768px) {\n    max-width: none;\n  }\n\n  .fio {\n    font-size: 24px;\n    line-height: 114%;\n    font-weight: 500;\n  }\n\n  .rating {\n    padding: 4px 12px 4px 9px;\n    background: #EFF3F5;\n    border-radius: 27px;\n    display: flex;\n    justify-content: center;\n    gap: 4px;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 117%;\n    align-items: center;\n\n    svg {\n      fill: #F2A60F;\n      width: 17px;\n      height: 17px;\n    }\n  }\n\n  @media (max-width: 640px) {\n    justify-content: space-between;\n\n    .fio {\n      font-size: 18px;\n    }\n\n    .rating {\n      font-size: 16px;\n    }\n  }\n}\n\n.info-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 12px;\n  margin-bottom: 20px;\n  max-width: calc(100% - 240px);\n\n  &__item {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n\n    span {\n      line-height: 114%;\n    }\n\n    .item__title {\n      color: #7A808B;\n      font-weight: 500;\n    }\n\n    .item__info {\n      font-size: 16px;\n    }\n\n    .item__info-container {\n      display: flex;\n      gap: 4px;\n      align-items: center;\n    }\n  }\n\n  @media (max-width: 640px) {\n    max-width: initial;\n    gap: 8px;\n    margin-bottom: 12px;\n\n    &__item {\n      padding-bottom: 8px;\n      border-bottom: 1px solid #F3F2F2;\n\n      .item__title {\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n.ProfileBlock__cropModal {\n  position: absolute;\n  right: 24px;\n  top: 24px;\n\n  @media (max-width: 768px) {\n    position: relative;\n    margin: 12px auto 0;\n    width: 100%;\n    align-items: center;\n    max-width: 304px;\n    top: initial;\n    right: initial;\n\n    :global {\n      .photo__container {\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n}\n\n.write-message__block {\n  margin-top: auto;\n  border-top: 1px solid #EFF3F5;\n\n  @media (max-width: 640px) {\n    border-top: 0;\n  }\n\n  .btn {\n    margin-top: 20px;\n    max-width: 240px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px;\n    background-color: var(--accent-color);\n    min-height: 24px;\n    border-radius: 12px;\n    font-size: var(--fz-sm);\n    line-height: var(--fz-lg);\n    color: white;\n    transition: var(--transition);\n    position: relative;\n\n    @media (hover: hover) {\n      &:hover {\n        opacity: 0.8;\n      }\n    }\n\n    &--is-loading {\n      svg {\n        opacity: 0;\n      }\n    }\n\n    svg {\n      flex-shrink: 0;\n      margin-right: 7px;\n    }\n\n    @media (max-width: 640px) {\n      max-width: none;\n      margin-top: 0;\n    }\n  }\n\n  .btn__icon-container {\n    position: relative;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ProfileBlock": `ProfileBlock_ProfileBlock__qPPTT`,
	"additional-information": `ProfileBlock_additional-information__9I4dg`,
	"fio-container": `ProfileBlock_fio-container__y1k5u`,
	"fio": `ProfileBlock_fio__R0CfG`,
	"rating": `ProfileBlock_rating__P0hhA`,
	"info-list": `ProfileBlock_info-list__RgRiQ`,
	"info-list__item": `ProfileBlock_info-list__item__LtEXN`,
	"item__title": `ProfileBlock_item__title__I0sI0`,
	"item__info": `ProfileBlock_item__info__a2FBy`,
	"item__info-container": `ProfileBlock_item__info-container__qzL4f`,
	"ProfileBlock__cropModal": `ProfileBlock_ProfileBlock__cropModal__fHUaP`,
	"write-message__block": `ProfileBlock_write-message__block__kvkc7`,
	"btn": `ProfileBlock_btn__wT2H0`,
	"btn--is-loading": `ProfileBlock_btn--is-loading__G6h4E`,
	"btn__icon-container": `ProfileBlock_btn__icon-container__ALFR3`
};
export default ___CSS_LOADER_EXPORT___;
